import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { apiService } from '../services/api';

const STORAGE_KEY = 'ml_referral';

// Read stored referral data — called at signup time
export const getReferralData = () => {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch { return null; }
};

// Call after a successful signup to prevent the code from being reused
export const clearReferralData = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
};

// Store + fire the tracking call; idempotent for the same code within a session
export const storeAndTrackReferral = (code, source = 'direct', page = 'unknown') => {
  if (!code) return;
  try {
    const existing = getReferralData();
    if (existing?.code === code) return; // already tracked this code
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ code, source }));
  } catch {}
  apiService.trackReferralClick({ referral_code: code, source, page }).catch(() => {});
};

// App-level hook: picks up ?ref_code=CODE&source=platform on any page
const useReferral = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code   = params.get('ref_code') || params.get('ref');
    if (!code) return;
    const source = params.get('source') || 'direct';
    const page   = location.pathname.replace(/^\//, '') || 'home';
    storeAndTrackReferral(code, source, page);
  }, [location.search]);
};

export default useReferral;
